export enum NavigationRoutesForRouter {
  OnCallUser = 'on-call-user',
  OnCallUserList = 'on-call-user-list',
  CurrentFacility = 'current-facility',
  OnCallLanding = 'on-call',
  ModuleTypeDetail = 'module-type-detail',
  UserDetail = 'user-detail',
  MyProfileUserDetail = 'my-profile-user-detail',
  UserRoleDetail = 'user-role-detail',
  RoleDetail = 'role-detail',
  PermissionDetail = 'permission-detail',
  ModuleTypeList = 'module-type',
  UserList = 'user',
  UserRoleList = 'user-role',
  UserRoleRequestList = 'user-role-request',
  UserRoleRequestDetail = 'user-role-request-detail',
  UserProfileRoleRequestList = 'user-profile-role-request',
  UserProfileRoleRequestDetail = 'user-profile-role-request-detail',
  RoleList = 'role-type',
  PermissionList = 'permissions',
  UserSetupLanding = 'user-setup',
  FacilitySetupLanding = 'facility-setup',
  ClinicalLanding = 'clinical',
  AdminLanding = 'admin',
  HealthcareserviceDetail = 'health-care-service-detail',
  FacilityDetail = 'facility-detail',
  UserProfile = 'user-profile',
  NotificationSettings = 'notification-settings',
  UserManageOwnRole = 'user-manage-own-role',
  SystemMessageDetail = 'system-message-detail',
  ReferralGuidanceMessage = 'referral-guidance-message',
  SpvList = 'spv-list',
  AdminRolesTabbed = 'admin-role-tabbed',
  UserProfileLanding = 'user-profile',
  formBuilder = 'form-builder',
  GlobalPatientSearch = 'global-patient-search',
  TrainingVideos = 'training-videos',
  TrainingVideoDetail = 'training-video-detail',
}
